var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterLevel14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.59 25h-40l5-6h39.82l-4.82 6zm6.55 5.28l-3.07-2.57L54.66 33H16v4h40.53l5.61-6.72zm0 10l-3.07-2.57L54.66 43H16v4h40.53l5.61-6.72zm0 10l-3.07-2.57L54.66 53H16v4h40.53l5.61-6.72z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_level_1-4.837ce7e3.svg";
export { SvgC1RollerShutterLevel14 as ReactComponent };